module.exports = __webpack_public_path__ + "static/media/jesse_farnham_resume.fff3f1bf.pdf";